import Vue from 'vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VueTreeselect from '@riophae/vue-treeselect';

Vue.component('treeselect', VueTreeselect);
